<template>
  <AppBtn
    href="https://steamcommunity.com/sharedfiles/filedetails/?id=1570316591&amp;searchtext=River+runes"
    class="manual-map-btn"
    color="red-grad"
    target="_blank"
    round
  >
    Открыть карту в
    <div class="manual-map-btn__steam-icon">
      <SvgIcon class="manual-map-btn__icon" size="40" name="steam-logo" />
    </div>
  </AppBtn>
</template>

<script>
export default {
  name: "ManualMapBtn"
};
</script>

<style lang="scss">
.manual-map-btn {
  margin: 0 auto;
  display: flex;
  width: 380px;
  height: 80px;
  max-width: 90%;
  font-size: 22px;
  font-weight: 800;

  &__icon {
    position: absolute;
    top: 5px;
    left: -3px;
  }

  &__steam-icon {
    border: 4px solid currentColor;
    border-radius: 50%;
    width: 54px;
    height: 54px;
    position: relative;
    margin-left: 10px;
  }

  @media (max-width: 400px) {
    font-size: 18px;
  }
}
</style>
